import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { messageError } from '../../constants';
import { CompositionSectionProps } from '../StructuredOperationSubDetailsSection';

export const StructuredOperationCompositionSection: React.FC<CompositionSectionProps> = ({
  composition,
  operation,
}) => {
  return (
    <VStack>
      <Box w={'full'} bg={'neutral.lightest'} h={'0.5'} my={Spacing['inline.xxxs']} />
      <VStack space={Spacing['inline.xxxs']}>
        <Text
          color={'brand.primary.principal'}
          variant="regular"
          fontSize={Typography['fontsize.md']}>
          {composition?.description || messageError}
          <Text
            fontWeight={'bold'}
            fontSize={Typography['fontsize.md']}
            color={'brand.primary.principal'}>
            {' '}
            {operation}.
          </Text>
        </Text>
        <VStack space={Spacing['inline.xxs']}>
          {composition?.details?.map((detail) => (
            <VStack space={Spacing['inline.xxs']} key={detail?.title}>
              <Text
                variant="bold"
                fontSize={Typography['fontsize.lg']}
                color={'brand.primary.principal'}>
                {detail?.title || messageError}
              </Text>
              <VStack space={Spacing['inline.nano']}>
                {detail?.item?.map((item) => (
                  <HStack
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    w={'full'}
                    key={item.description}>
                    <Text
                      fontSize={Typography['fontsize.md']}
                      variant="regular"
                      color={'neutral.dark'}>
                      {item?.description || messageError}
                    </Text>
                    <Text
                      variant="bold"
                      color={'brand.primary.principal'}
                      fontSize={Typography['fontsize.md']}>
                      {item?.value || messageError}
                    </Text>
                  </HStack>
                ))}
              </VStack>
            </VStack>
          ))}
        </VStack>
      </VStack>
    </VStack>
  );
};
